import _ from "lodash";
import React from "react";
import { compose } from "lib/apolloClient";
import { connect } from "react-redux";
import classes from "./CroppableImageDropZone.scss";
import PropTypes from "prop-types";
import DropzoneComponent from "UIComponents/DropzoneComponent";
import I18nHOC from "UIComponents/I18nHOC";
import { generateRandomId, getAttachmentSendObj } from "Utils";
import classNames from "classnames";
import UIBaseComponent from "UIComponents/UIBaseComponent";
import ResourceBank from "AppComponents/ResourceBank";
import { uploadFileV2 } from "modules/Services";
import { CropModal } from "@toddle-edu/ds-web";

class CroppableImageDropZone extends UIBaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      isDeleted: false,
      uploadObj: {},
      uploadingImage: false,
      showMediaModal: false,
      showResourceBank: false,
      fileCount: 0,
      file: "",
      showCropModal: false,
      uploadedImage: {},
    };

    this.dropzoneRef = React.createRef();
  }

  onCancel = () => {
    this.setState({ file: "" });
  };

  onUpdateValue = value => {
    this.updateValue(value);
  };

  onDropzoneImageUpload = files => {
    const file = _.first(files);
    if (!_.isEmpty(file)) {
      if (this.props.showCroppingModal) {
        this.setState({ showCropModal: true });
        this.setState({ uploadedImage: file });
      } else {
        const imgUrl = _.get(file, "url", "");
        this.onUpdateValue(imgUrl);
      }
    }
  };

  dataURLtoBlob = dataUrl => {
    var arr = dataUrl.split(","),
      mimeMatch = arr[0].match(/:([^;]*)/),
      mime = mimeMatch ? mimeMatch[1] : "text/plain",
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new Blob([u8arr], { type: mime });
  };

  onCropModalClose = () => {
    this.setState({ showCropModal: false });
  };

  onCrop = async image => {
    if (!image) {
      return;
    }
    this.onCropModalClose();
    try {
      // convert base64 img to blob url and create file object
      const blob = this.dataURLtoBlob(image);
      const type = blob.type;
      const preview = URL.createObjectURL(blob);
      const imgName = _.get(this.state.uploadedImage, "name", "");
      const file = new File([blob], imgName, { type });
      file.preview = preview;

      // upload file to S3 and return uploaded img url
      const sendObj = await getAttachmentSendObj(file, `${file.preview}`);
      const imgUrl = await this.props.uploadFileV2({
        file,
        attachment: sendObj,
        uploadId: generateRandomId(),
      });

      if (!_.isEmpty(imgUrl)) {
        this.onUpdateValue(imgUrl);
      }
    } catch (error) {
      console.error("Error uploading cropped image:", error);
    }
  };

  onDeleteClick = () => {
    this.onUpdateValue("");
    if (this.props.showCroppingModal) {
      this.setState({
        uploadedImage: {},
      });
    }
  };

  onSingleContentUploaded = async params => {
    this.onUpdateValue(params.url);
    this.onUploaded();
  };

  onUploaded = () => {
    this.setState({ uploadingImage: false, uploadObj: {} });
    this.onBlur();
  };

  onDropContent = params => {
    const { onDropContent } = this.props;
    this.setState({ uploadObj: params });
    onDropContent && onDropContent();
  };

  updateFilesCount = count => {
    const fileCount = this.state.fileCount;
    this.setState({
      uploadingImage: fileCount + count > 0,
      fileCount: fileCount + count,
    });
    this.onFocus();
  };

  onCancelPressed = e => {
    this.setState({ uploadObj: {} });
    this.onUpdateValue("");
    e.stopPropagation();
  };

  onAddFromUnsplash = () => {
    this.toggleResourceBank(true);
  };

  onAddFromPixabay = () => {
    this.toggleResourceBank(true);
  };

  toggleMediaModal = value => {
    this.setState({ showMediaModal: value });
  };

  dropzoneRenderComponent = () => {
    const {
      progressOfUploads,
      value,
      parentId,
      parentType,
      uploadingObjRedux,
      customUploadComponent,
    } = this.props;
    const { uploadObj: uploadObjState, uploadingImage } = this.state;

    const uploadObj =
      (!!parentType && !!parentId) || !_.isEmpty(uploadingObjRedux)
        ? _.get(uploadingObjRedux, "attachment", {})
        : uploadObjState;
    const progressValue = parseInt(
      _.get(
        progressOfUploads,
        `${this.state.uploadObj.id}.progress`,
        uploadingImage ? "0" : "100"
      )
    );

    const onUploadFromDevice = () =>
      this.dropzoneRef.current.refs.wrappedInstance.dialogueBoxConfirm();

    const localUrl = this.state.file || uploadObj.url;

    // Use original image
    const image = localUrl || value || "";

    if (React.isValidElement(customUploadComponent)) {
      return React.cloneElement(customUploadComponent, {
        image,
        onUploadFromDevice,
        onAddFromPixabay: this.onAddFromPixabay,
        onDeleteClick: this.onDeleteClick,
        progressValue,
      });
    }
  };

  renderDropZone = () => {
    const { accept, testId, showCroppingModal } = this.props;

    const renderComponent = this.dropzoneRenderComponent();

    return (
      <DropzoneComponent
        ref={this.dropzoneRef}
        accept={accept}
        multiple={false}
        onContentUploaded={this.onDropzoneImageUpload}
        renderComponent={renderComponent}
        testId={`${testId}-imageDropzone`}
        shouldUpload={!showCroppingModal}
      />
    );
  };

  toggleResourceBank = (value = false) => {
    this.setState({ showResourceBank: value });
  };

  addResources = () => {};

  renderEdit = () => {
    const {
      uploadBoxStyles,
      cardSize,
      isDisabled,
      parentType,
      fieldParentType,
      parentId,
      dsVersion,
      fieldParentId,
      ratio,
    } = this.props;
    const { showResourceBank, showCropModal, uploadedImage } = this.state;

    const component = this.renderDropZone();
    const uploadImageComponentClass = classNames(
      { [classes.uploadImageComponent]: true },
      { [classes.smallUploadImageComponent]: cardSize == "small" }
    );
    const uploadedImageUrl = _.get(uploadedImage, "url", "");
    return (
      <div className={uploadImageComponentClass} style={uploadBoxStyles}>
        {component}
        {showCropModal ? (
          <CropModal
            ratio={ratio}
            onClose={this.onCropModalClose}
            onAdd={this.onCrop}
            image={uploadedImageUrl}
            dsVersion={dsVersion}
            restrictCroppingToImage={true}
          />
        ) : null}
        {isDisabled && <div className={classes.disbaledImageContainer}></div>}
        {!!showResourceBank && (
          <ResourceBank
            id={"CREATE_DROPDOWN"}
            onDropContent={this.onDropContent}
            multi={false}
            onSingleContentUploaded={this.onSingleContentUploaded}
            updateFilesCount={this.updateFilesCount}
            closeResource={this.toggleResourceBank}
            onAddClick={this.addResources}
            parentType={parentType}
            fieldParentType={fieldParentType}
            fieldParentId={fieldParentId}
            parentId={parentId}
            dsVersion={dsVersion}
          />
        )}
      </div>
    );
  };
}

CroppableImageDropZone.propTypes = {
  ...UIBaseComponent.propTypes,
  onCancelPressed: PropTypes.func,
  onDropContent: PropTypes.func,
  testId: PropTypes.string,
  dsVersion: PropTypes.string,
};

CroppableImageDropZone.defaultProps = {
  ...UIBaseComponent.defaultProps,
  cardSize: "large",
  ratio: "16:9",
  showUnsplash: true,
  shouldUpload: true,
  buttonSize: "medium",
  onDropContent: _.noop,
  showCroppingModal: false,
  testId: "UIComponents",
  dsVersion: "2.0",
};

const mapActionCreators = {
  uploadFileV2,
};

const mapStateToProps = (state, ownProps) => {
  const progressOfUploads = _.get(state, "app_services.progressOfUploads", {});
  const imageTypes = "image/jpeg,image/png,image/jpg,image/heic,image/heif";
  const accept = imageTypes;

  return {
    progressOfUploads,
    uploadingObjRedux:
      _.find(
        Object.values(progressOfUploads),
        item =>
          item.parentType == ownProps.parentType &&
          item.parentId == ownProps.parentId
      ) || {},
    accept,
  };
};

export default compose(
  I18nHOC({ resource: "common" }),
  connect(mapStateToProps, mapActionCreators)
)(CroppableImageDropZone);
